/**
 * File: apps/qbench-cp/reactapp/src/App/styles.js
 *
 * Purpose: Styled-components definitions for the authenticated app layout.
 *
 * Scope: Root layout wrapper used by the LoggedInApp view in App/index.js.
 *
 * Tags: customer-portal
 *
 * Overview: Exports a single styled div, StyledLoggedInApp, that fills the viewport and lays
 *     out its children (top nav, announcements, dashboard) in a column flex container with
 *     hidden overflow.
 *
 * Exports: StyledLoggedInApp — styled div used as the outer wrapper for the authenticated app.
 */

import styled from 'styled-components';

export const StyledLoggedInApp = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
